$(document).ready(function () {
  // ============== START HEADER JS ============= //
  function headerspace() {
    var headerHeight = $(".header").outerHeight();
    $(".wrapper").css("padding-top", headerHeight);
  }
  headerspace();
  $(window).on("resize load scroll", headerspace);
  $(window).on("scroll", function () {
    if ($(window).scrollTop() > 40) {
      $("header").addClass("sticky");
    } else {
      $("header").removeClass("sticky");
    }
  });

  $("body").on("click", ".header-menu-icon", function () {
    $(".header-mobile-menu, .overlay-pop").addClass("open");
  });
  $("body").on(
    "click",
    ".header-mobile-menu-inner .header-menu-icon, .overlay-pop",
    function () {
      $(".header-mobile-menu, .overlay-pop").removeClass("open");
    }
  );
  $("body").on("click", ".menu-dropdown-items .arrow-icon", function () {
    if ($(this).parents(".menu-dropdown-items").hasClass("open")) {
      $(this).parents(".menu-dropdown-items").removeClass("open");
      $(this)
        .parents(".menu-dropdown")
        .find(".menu-dropdown-content")
        .slideUp(200);
      $(".menu-dropdown-items-inner").removeClass("open");
      $(".menu-dropdown-content-inner").slideUp(200);
    } else {
      $(this).parents(".menu-dropdown-items").addClass("open");
      $(this)
        .parents(".menu-dropdown")
        .find(".menu-dropdown-content")
        .slideDown(200);
    }
  });
  $("body").on("click", ".menu-dropdown-items-inner .arrow-icon", function () {
    if ($(this).parents(".menu-dropdown-items-inner").hasClass("open")) {
      $(this).parents(".menu-dropdown-items-inner").removeClass("open");
      $(this)
        .parents(".menu-dropdown-inner")
        .find(".menu-dropdown-content-inner")
        .slideUp(200);
    } else {
      $(this).parents(".menu-dropdown-items-inner").addClass("open");
      $(this)
        .parents(".menu-dropdown-inner")
        .find(".menu-dropdown-content-inner")
        .slideDown(200);
    }
  });
  // ============== END HEADER JS ============= //
  // ============== START MARQUEE SLIDER JS ============= //
  var mSlider = new Swiper(".m-slider", {
    spaceBetween: 0,
    speed: 3000,
    loop: true,
    Infinity:true,
    slidesPerView: "auto",
    centeredSlides: true,
    direction: 'horizontal',
    keyboardControl: false,
    mousewheelControl: false,
    allowTouchMove: false,
    autoplay: {
      delay: 0.5,
    },
    disableOnInteraction: true,
  });
  // ============== END MARQUEE SLIDER JS ============= //
  // ============== START FAQ SECTION JS ============= //
  $("body").on("click", ".faq-tab-header", function (f) {
    f.preventDefault();
    if ($(this).hasClass("active")) {
      $(this).removeClass("active");
      $(this).siblings(".faq-tab-body").slideUp(200);
    } else {
      $(".faq-tab-header").removeClass("active");
      $(this).addClass("active");
      $(".faq-tab-body").slideUp(200);
      $(this).siblings(".faq-tab-body").slideDown(200);
    }
  });
  // ============== END FAQ SECTION JS ============= //
  // ============== START SEARCH BAR JS ============= //
  if(!$("body").hasClass("template-search")){
    $("body").on("click", ".search-icon-btn", function () {
      $(".search-bar-main").slideDown(300);
      $("body").addClass("scroll-hidden");
      $(".search-bar .search-input").focus();
    });
    $("body").on("click", ".search-bar-inner .search-close-btn", function () {
      $(".search-bar-main").slideUp(300);
      $("body").removeClass("scroll-hidden");
    });    
  }
  // ============== END SEARCH BAR JS ============= //
  // ============== START ADD TO CART JS ============= //
  function updateSideCart() {
    $.get('/cart?view=mini-cart',function(data){
      $('.cart-popup').html(data);
      $('.cart-popup').addClass("opne_cart");
      $('.cart-overlay').addClass("is_open");
      $('body').addClass("overflow_hidden");
    });   
  }
  function countCart(){
    $.getJSON('/cart.js',function(data){
      $('.cart_count').html(data.item_count);
    });
  }  
  // product add to cart call
  Shopify.addItem = function(form_data, button) {
    var params = {
      type: 'POST',
      url: '/cart/add.js',
      data: form_data,
      dataType: 'json',
      success: function(data) { 
        updateSideCart();
        countCart();
        button.removeClass('loading');
      },
      error: function(XMLHttpRequest, textStatus) {
        Shopify.onError(XMLHttpRequest, textStatus);
        button.removeClass('loading');
      }
    };
    jQuery.ajax(params);
  };
  
  $('body').on('click', '.add__submit-button:not(.disabled)', function(e) {
    e.preventDefault();
    var $button = $(this);
    var $form = $button.closest('form');
    var form_data = $form.serialize();
    
    $button.addClass('loading');
    Shopify.addItem(form_data, $button);
  });
  
  // remove and update item from the cart
    $('body').on('click', '.product-quantity-box .adjust', function(e) {
        e.preventDefault();
        var input = $(this).parent().find('input');
        var ip = parseInt(input.val());
        if ($(this).hasClass('product-plus')) {
            ip = ip + 1;
        } else {
            ip = ip - 1;
        }
        input.val(ip);
        var update_id = $(this).parents(".mini-cart__item").attr('data-attr');
        var qty = parseInt(input.val());
        if (update_id != '' && update_id != undefined && update_id != null) {        
          $('.mini-cart__item[data-attr="' + update_id + '"]').each(function(i, v) {
              var update_line = $(v).attr('data-id');
              $.ajax({
                  type: "POST",
                  url: "/cart/update.js",
                  data: 'updates[' + update_line + ']=' + qty,
                  dataType: "json",
                  async: false,
                  error: function(jqXHR, textStatus, errorThrown) {
                    var response = $.parseJSON(jqXHR.responseText);
                    console.error("Update error: ", response);
                  }
              }).done(function(data) {
                  updateSideCart();
                  countCart();
              });            
          });                 
        } else {
          var id = parseInt(input.attr('data-line'));
          $.ajax({
              type: "POST",
              url: "/cart/update.js",
              data: "updates[" + id + "]=" + ip,
              dataType: "json",
              error: function(jqXHR, textStatus, errorThrown) {
                var response = $.parseJSON(jqXHR.responseText);
                console.error("Update error: ", response);
              }
          }).done(function(data) {
              updateSideCart();
              countCart();
          });
        }
    });

  // bundle add to cart button
  function randomNumber(min, max) {  
    min = Math.ceil(min); 
    max = Math.floor(max); 
    return Math.floor(Math.random() * (max - min + 1)) + min; 
  }    
  
  $('body').on('click', '.bundle__submit-button', function(e) {
      e.preventDefault();
      if ($('.better-together-items-bundle .better-together-items-img input:checked').length === 0) {
        alert('Please select at least one product.');
        return;
      }  
      var $button = $(this);
      var viewData = { items: [] };
      var bundleId = randomNumber(100000000000, 10000000000000);  
      $('.better-together-items.active').each(function() {
          var input = $(this).find('.better-together-items-img input');
          var id = input.attr('data-variant-id');
          if (id) {
            viewData.items.push({
              id: id,
              quantity: 1,
              properties: { '_bundle_number': bundleId }
            });
          }
      });  
      $button.addClass('loading');
      if (viewData.items.length > 0) {
        $.ajax({
          type: 'POST',
          url: '/cart/add.js',
          data: JSON.stringify({ items: viewData.items }),
          contentType: 'application/json',
          dataType: 'json',
          success: function() {
            updateSideCart();
            countCart();
            $button.removeClass('loading');
          },
          error: function(jqXHR, textStatus, errorThrown) {
            console.error('Error adding items to the cart:', textStatus, errorThrown);
            alert('There was an error adding items to the cart. Please try again.');
            $button.removeClass('loading');
          }
        });
      }
  });  
  function randomNumber(min, max) {
      return Math.floor(Math.random() * (max - min + 1)) + min;
  }
  
  // ============== END ADD TO CART JS ============= //  
  // ============== START Remove btn JS ============= //
      $("body").on('click', '.remove-btn', function (event) {
        event.preventDefault();
        var cartItem = $(this).closest('.mini-cart__item');
        var currentVariantid = cartItem.find('input').attr('data-line');
        
        var update_id2 = cartItem.attr('data-attr');
        
        if (update_id2 != '' && update_id2 != undefined && update_id2 != null) {        
          $('.mini-cart__item[data-attr="' + update_id2 + '"]').each(function(i, v) {
              var update_line2 = $(v).attr('data-id');
             console.log('update_line2',update_line2);
                $.ajax({
                  type: "POST",
                  url: "/cart/update.js",
                  data: 'updates[' + update_line2 + ']=' + 0,
                  dataType: "json",
                  async: false,
                  error: function(jqXHR, textStatus, errorThrown) {
                    var response = $.parseJSON(jqXHR.responseText);
                    console.error("Update error: ", response);
                  }
              }).done(function(data) {
                  updateSideCart();
                  countCart();
              });        
          });                 
        }else{
              $.ajax({
                  type: "POST",
                  url: "/cart/update.js",
                  data: "updates[" + currentVariantid + "]=" + 0,
                  dataType: "json",
                  error: function(jqXHR, textStatus, errorThrown) {
                    var response = $.parseJSON(jqXHR.responseText);
                    console.error("Update error: ", response);
                  }
              }).done(function(data) {
                  updateSideCart();
                  countCart();
              });
         }
    });
  // ============== END Remove btn JS ============= //
  // ============== START COLLECTION SCROLL JS ============= //  
   $('body').on('click' , '.collection-category-left .block-menu a' , function(e){
      e.preventDefault();
      var header_height = $('.header').height();    
      var href = $(this).attr('href');
      var deskscroll_section = $(href).offset().top; 
      $('html, body').animate({
        scrollTop: deskscroll_section - header_height
      },100);       
    });
  // ============== END COLLECTION SCROLL JS ============= //  

  // ============== START PRODUCT JS ============= //  
  var productSliderThum = new Swiper(".product-slider-thum", {
    centeredSlides: false,
    centeredSlidesBounds: true,
    slidesPerView: "auto",
    watchOverflow: true,
    watchSlidesVisibility: true,
    watchSlidesProgress: true,
    direction: "horizontal",
    spaceBetween: 10,
    navigation: {
      nextEl: '.slider__next',
      prevEl: '.slider__prev'
    },
    breakpoints: {
      600: {
        direction: "vertical",
        spaceBetween: 0,
        slidesPerView: 4,
      },
    },
  });
  if($('.product-right-main-image').length > 0){
    var productMainSlider = new Swiper(".product-main-slider", {
      loop: false,
      spaceBetween: 12,
      slidesPerView: "auto",
      navigation: {
        nextEl: '.slide_next',
        prevEl: '.slide_prev'
      },
      thumbs: {
        swiper: productSliderThum,
      },
    });    
  }
  
  // go to the selected variant image
  if($('.variant-radios').length > 0){
    var main_image = $('.product-main-inner').attr('data-main-image');
    $('.product-slider-thum-items').each(function(index) {
      var thumb_image = $(this).attr('data-image-url');
      if (thumb_image === main_image) {
        productSliderThum.slideTo(index);
        productMainSlider.slideToLoop(index);
        return false;
      }
    });    
  }
  
  // get variant data
  function renderProductInfo(currentVariant, sectionId, dataProductURL, productId) {
    fetch(dataProductURL+'?variant='+ currentVariant.id)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html'), 
              price = '#price-'+sectionId,
              addtocartbtn = '[name="add"]';
        
        if ($(price).length > 0) $(price).html($(html).find('#price-'+sectionId).html());
        var main_image = $(html).find('.product-main-inner').attr('data-main-image');
        $('.product-slider-thum-items').each(function(index) {
          var thumb_image = $(this).attr('data-image-url');
          if (thumb_image === main_image) {
            productSliderThum.slideTo(index);
            productMainSlider.slideToLoop(index);
            return false;
          }
        });    
        
        var isNotifyMe = $(html).find('[name="add"]'),
            isdisabled = $(isNotifyMe).hasClass("disabled");
            isdisabledbutton = $(isNotifyMe).attr("disabled");
        
        if ($(addtocartbtn).length > 0) $(addtocartbtn).html($(html).find('[name="add"]').html());
        if (isdisabled ? $(addtocartbtn).addClass('disabled') : $(addtocartbtn).removeClass('disabled'));
        if (typeof isdisabledbutton !== 'undefined' && isdisabledbutton !== false ? $(addtocartbtn).attr('disabled','disabled') : $(addtocartbtn).removeAttr('disabled'));
      });
  }
  $('.variant-radios input').change(function () {
  var variantSelect = $(this).parents('[data-variant-options]'),
      dataSection = variantSelect.data('section'),
      dataProductURL = variantSelect.data('url'),
      variantData = JSON.parse(variantSelect.find('[type="application/json"]').text()),
      productId = variantSelect.data('product-id');
    
      var options = $(this).get(0).tagName == 'SELECT' 
          ? Array.from(variantSelect.find('select'), (select) => $(select).val()) 
          : variantSelect.find('.product-form__input').map(function(index, fieldset) {
            return $(fieldset).find('input:checked').val();
          }).get();
    
      var currentVariant = variantData.find((variant) => {
        return !variant.options
          .map((option, index) => {
            return options[index] === option;
          }).includes(false);
      });   
      window.history.replaceState({}, '', dataProductURL+'?variant='+currentVariant.id);       
      const productForms = $('#product-form-'+dataSection);
      productForms.find('[name="id"]').val(currentVariant.id);              
      renderProductInfo(currentVariant, dataSection, dataProductURL, productId);
  });  
  
  // ============== END PRODUCT JS ============= // 

  // ============== SIDE CART JS ============= // 
  // $("body").on("click" , ".you_like_text" , function(e){
  //   e.preventDefault();
  //   $('.you_may_like').toggleClass("active");
  //    $(".may-like-product-grid").slideToggle();
  // });

 // ============== BEST-SELLER-SECTION JS ============= // 
  var swiper = new Swiper(".product_list_slider", {
    slidesPerView: "1",
    spaceBetween: 10,
    breakpoints: {
      480: {
        spaceBetween: 10,
        slidesPerView: 2,
      },
      768: {
        spaceBetween: 10,
        slidesPerView: 3,
      },
      992: {
        spaceBetween: 23,
        slidesPerView: 4,
      },
    },
    pagination: {
        el: '.best-seller-pagination',
        clickable: true
    },
  });

  // ============== GAME-SECTION JS ============= // 
  var swiper = new Swiper(".prod_collection_slider", {
    slidesPerView: "1",
    spaceBetween: 10,
    breakpoints: {
      480: {
        spaceBetween: 10,
        slidesPerView: 2,
      },
      768: {
        spaceBetween: 10,
        slidesPerView: 3,
      },
    },
    pagination: {
        el: '.best-seller-pagination',
        clickable: true
    },
  });


$(document).ready(function() {
  // Select the product-main-slider element
  var $slider = $('.product-main-slider');
  
  // Find all swiper-slide elements inside the product-main-slider
  var $slides = $slider.find('.swiper-slide');
  
  // Check if the number of slides is 1
  if ($slides.length === 1) {
    // Add the one_slide class to the product-main-slider
    $slider.addClass('one_slide');
  }
});

$(document).ready(function(){
  // bundle js start
    var index = 0;
    var productData = [];
    var bundleTotalPrice =0;

   
    // function updateQty(productId=0, Index){
    //     let inputFind = $(".product-btn[data-product_id="+productId+"]");
    //     let qty = inputFind.find("input[type='number']").val();
    //     productData.splice(Index,1)
    // }
    function addBundleProduct(e, index){   
          console.log("EEEEEEE 1", e, "index == ", index)
          // let findElement = $(".this_item_active");
          // let productImgSrc = $(".this_item_active").find(".best-seller-fimage img").attr("src");
          // let productTitle = $(".this_item_active").find(".best-seller-content .title p").text();
          let productPrice = $(".this_item_active").find(".product-price").attr("data-product_price");
          let productCPrice = $(".this_item_active").find(".product-price").attr("data-product_Cprice");
          // let productId = $(".this_item_active").find(".product-price").attr("data-product_id");
          let productdata = []
         
          productdata.push(index)
          productdata.push($(".this_item_active").find(".best-seller-fimage img").attr("src"));
          productdata.push($(".this_item_active").find(".best-seller-content .title p").text());
          productdata.push($(".this_item_active").find(".product-price").attr("data-product_price"));
          productdata.push($(".this_item_active").find(".product-price").attr("data-product_id"));
          productData.push(productdata)
          console.log("productdata", productdata);
          // updateBundleCPrice( productCPrice, "plus" );  
          addProductAsBundle( productData ) //Calling function       
          updateBundlePrice( productPrice,"plus" );  


       setTimeout(function() {
          $(".best-seller-items").removeClass("this_item_active");
        }, 200);

    }
Shopify.formatMoney = function(cents, format) {
  if (typeof cents == 'string') { cents = cents.replace('.',''); }
  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = (format || this.money_format);

  function defaultOption(opt, def) {
     return (typeof opt == 'undefined' ? def : opt);
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal   = defaultOption(decimal, '.');

    if (isNaN(number) || number == null) { return 0; }

    number = (number/100.0).toFixed(precision);

    var parts   = number.split('.'),
        dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
        cents   = parts[1] ? (decimal + parts[1]) : '';

    return dollars + cents;
  }

  switch(formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
  }

  return formatString.replace(placeholderRegex, value);
};
var shop_money_format = $('body').attr('data-shop-moneyformat');
  
function updateBundlePrice(productPrice = 0, operator) {
  if (operator == "plus") {
    bundleTotalPrice = parseInt(bundleTotalPrice) + parseInt(productPrice);
  } else {
    bundleTotalPrice = parseInt(bundleTotalPrice) - parseInt(productPrice);
  }
  let totalprice = Shopify.formatMoney(bundleTotalPrice,shop_money_format);
  console.log(totalprice,"totalprice")
  $(".bundle_total_price").attr("data-totale_price", bundleTotalPrice);
     let discountPercentage = 10;
     // Calculate the discount amount
     let discountAmount = (bundleTotalPrice * discountPercentage) / 100;
     // Calculate the final price after applying the discount
     let finalPrice = bundleTotalPrice - discountAmount;
     let totalSaleprice = Shopify.formatMoney(finalPrice, shop_money_format)
      
     $(".bundle_total_price ").html(totalSaleprice);
     $(".compare_price_new").html(totalprice);
    $(".bundle_total_price ").show();
}


  
    function addProductAsBundle(data=0){
        var randomClass = '';
        productData = data;
        $(".plus_btn").removeClass("disabled")
        $(".bundle_page_btn").addClass("disabled");
        let totalBlock = $(".bundle-product-list").data("total_block");
        /* Disabled button */
        if( productData.length >=totalBlock ){
            $(".plus_btn").addClass("disabled");
            $(".bundle_page_btn").removeClass("disabled");
        }
        
        $(".bundle-builder__selected-product").removeClass("active");
        $(".bundle-builder__selected-product").find("img[data-bundle-builder-selected-product-image]").attr('src', "");
        $(".bundle-builder__selected-product").find("[data-bundle-builder-selected-product-title]").text("");
        $(".bundle-builder__selected-product").attr("data-bundle-builder-selected-product-id"," ");
        $(".bundle-builder__selected-product").attr("data-bundle-builder-selected-product-price"," ");
        
        if( productData.length > 0 ){
            productData.forEach(function(item, inx){              
                let getElement = $(".bundle-builder__selected-product[data-index="+inx+"]");
                if( getElement.length > 0){       
                  console.log("getElement true")
                    getElement.addClass("active");
                    if (item[1] != undefined) {
                      getElement.find("img[data-bundle-builder-selected-product-image]").attr('src', item[1]);
                    }else{
                       getElement.find("img[data-bundle-builder-selected-product-image]").attr('src', 'https://cdn.shopify.com/s/files/1/0545/8834/2457/files/default_pdp_img.png?v=1722598074');
                    }
                    getElement.find("[data-bundle-builder-selected-product-title]").text(item[2]);
                    getElement.attr("data-bundle-builder-selected-product-price", item[3]);
                    getElement.attr("data-bundle-builder-selected-product-id",item[4]);
                }else{
                  console.log("getElement false")
                }
            })
        }   

    }


    $('body').on('click', '.bundle_page_btn', function(e) {
     
      e.preventDefault();
      var $button = $(this);
      
      var viewData = { items: [] };
   
      var bundleId = randomNumber(100000000000, 10000000000000);  
      $('.bundle-builder__selected-product.active').each(function() {
      
          var input = $(this).attr('data-bundle-builder-selected-product-id');
      
          var id = input;
          if (id) {
            viewData.items.push({
              id: id,
              quantity: 1,
              properties: { '_bundle_number': bundleId }
            });
          }
      });  
      console.log("viewData",viewData )
      $button.addClass('loading');
      if (viewData.items.length > 0) {
        $.ajax({
          type: 'POST',
          url: '/cart/add.js',
          data: JSON.stringify({ items: viewData.items }),
          contentType: 'application/json',
          dataType: 'json',
          success: function() {
            updateSideCart();
            countCart();
            $button.removeClass('loading');
          },
          error: function(jqXHR, textStatus, errorThrown) {
            console.error('Error adding items to the cart:', textStatus, errorThrown);
            alert('There was an error adding items to the cart. Please try again.');
            $button.removeClass('loading');
          }
        });
      }
  });  


  
  $("body").on("click", ".plus_btn", function(e){
      if ($('.this_item_active').length == 0) {
       $(this).parent(".best-seller-content").parent(".best-seller-items").addClass("this_item_active");
    console.log("fjghhfg",  $(this).parent(".best-seller-content").parent(".best-seller-items"))
      console.log("olus btn click")
        $(this).text("Ajouté");
        $(this).addClass("qty_increased");
        $(this).closest('.product-btn').removeClass("no-quantity");

        let qty = $(this).closest(".product-btn").find("input[type='number']").val();        
        $(this).closest(".product-btn").find("input[type='number']").val(parseInt(qty)+1);
    
        // if ($(that).hasClass('disabled')) {
        //    addBundleProduct(e, index)
        // }

        addBundleProduct(e, index)
    
        setTimeout(function() {
          
          if( productData.length >=$(".bundle-product-list").data("total_block") ){
              $(".plus_btn").addClass("disabled");
          }else{
            // $(that).removeClass("disabled")
          }
          
        }, 50);
        // progressBar()
        index += 1;
    }
    })

    // on remove update "ADD" text start

    // on remove update "ADD" text End
       $("body").on("click",".bundle_close_icon", function(){
           // $(".bundle_price").removeClass("compare_price")
            $(this).closest('.bundle_sec_product').removeClass("active");
            let Index = $(this).closest(".bundle-builder__selected-product").attr("data-index");
            let productId = $(this).closest(".bundle-builder__selected-product").attr("data-bundle-builder-selected-product-id");
        
           $('[data-prod-id="'+productId+'"]').html('Ajouter au panier');
            let productPrice = $(this).closest(".bundle-builder__selected-product").attr("data-bundle-builder-selected-product-price");
            // updateQty(productId, Index);
           productData.splice(Index,1)
            setTimeout(function() {
              addProductAsBundle(productData);
              updateBundlePrice(productPrice,"minus")
            }, 50);
         
            let activeCount = $(".bundle_sec_product.active").length;
              console.log("activeCount");
     });
});
  
// bundle js end
  
        // extra product start
        $('body').on('click', '.exrta_pdp_btn', function(event) {
          event.preventDefault(); // prevent default form submission
            var id = $(".product_tip_btn").find('input').attr('data-variant-id');
          $.ajax({
            type: 'POST',
            url: '/cart/add.js',
            data: {
              id:id,
              quentity:1
            },
            dataType: 'json',
            success: function(product) {
                    updateSideCart();
                    countCart();
            },
            error: function() {
               console.error('Error adding items to the cart:')
            }
          });
        });
        // extra product end

  // sticky btn start
        if ($(window).width() <= 991) {
          
          function checkVisibility() {
            var button = $('#myButton');
            var button_div = $('.product-bag-button');
            var buttonOffset = button_div.offset();
            var buttonHeight = button_div.outerHeight();
            var buttonWidth = button_div.outerWidth();
            var windowTop = $(window).scrollTop();
            var windowBottom = windowTop + $(window).height();
            var windowLeft = $(window).scrollLeft();
            var windowRight = windowLeft + $(window).width();
            
            if (buttonOffset.top  <= windowTop || 
              buttonOffset.top >= windowBottom ) {
              button.addClass('sticky_btn');      
            } else {              
              button.removeClass('sticky_btn');
            }
          }
                
          $(window).on('scroll', function() {
            checkVisibility();
          });          
          checkVisibility();          
        }
  
      // new start
      // function aliFunction(ali) {
      //     if (ali.matches) { // If media query matches
      //       $(window).scroll(function(){
      //         let Btn_position = document.querySelector(".btn-position-get");
      //         //let Btn_position = $(".btn-position-get");
      //         const Btnpostion = Btn_position.offsetTop;
      //         if ($(window).scrollTop() >= Btnpostion) {
      //           $('#myButton').addClass('fixed-sticky-cart');
      //               // $('.product-hero').addClass('has-sticky-cart');
      //         }else {
      //           $('#myButton').removeClass('fixed-sticky-cart');
      //           // $('.product-hero').removeClass('has-sticky-cart');
      //         }
      //       });
      //     } 
      // }
      // var ali = window.matchMedia("(max-width: 991px)")
      // aliFunction(ali) // Call listener function at run time
      // ali.addListener(aliFunction) // Attach listener function on state changes
      // new end

  
      //  sticky button end

        
});
